export default __webpack_public_path__ + "static/media/servicebnr1.377e5bf1.jpg";